import apiClient from "../../../services/apiClient";
import API_ENDPOINTS from "../../../config/apiEndpoints";
import { getUserData } from "../../../services/apiService";

export function readStoredSignature(userData) {
  try {
    let stored = sessionStorage.getItem("SignatureBase64");
    const fromUser =
      userData?.SignatureBase64 ||
      userData?.ESignature ||
      userData?.signatureBase64 ||
      null;
    if (!stored && fromUser) {
      stored = fromUser;
      sessionStorage.setItem("SignatureBase64", stored);
    }
    return stored || null;
  } catch {
    return null;
  }
}

export function typedSignatureToDataUrl(text) {
  if (!text || !String(text).trim()) return null;
  const canvas = document.createElement("canvas");
  canvas.width = 400;
  canvas.height = 160;
  const ctx = canvas.getContext("2d");
  if (!ctx) return null;
  ctx.fillStyle = "#f8f9fa";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = "#1a1a1a";
  ctx.font =
    'italic 42px "Dancing Script", "Brush Script MT", "Segoe Script", cursive';
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(String(text).trim(), canvas.width / 2, canvas.height / 2);
  return canvas.toDataURL("image/png");
}

/**
 * Persist e-signature for the current user (same API as eISF / profile).
 * @returns {Promise<{ success: boolean, signature?: string, message?: string }>}
 */
export async function saveSignatureForCurrentUser(signatureDataUrl) {
  const userData = getUserData() || {};
  const staffId = userData.StaffId || userData.staffId;
  const organizationId = userData.OrganizationId || userData.Organizationid;
  if (!signatureDataUrl || !staffId || !organizationId) {
    return {
      success: false,
      message: "Unable to save signature. Please sign in again.",
    };
  }

  try {
    const response = await apiClient.post(API_ENDPOINTS.USER.SAVE_ESIGNATURE, {
      StaffId: staffId,
      OrganizationId: organizationId,
      SignatureBase64: signatureDataUrl,
      CreatedBy: staffId,
      Action: "UpdateSignature",
    });
    const success = response?.success === 1 || response?.data?.success === 1;
    if (!success) {
      return {
        success: false,
        message:
          response?.data?.message ||
          response?.message ||
          "Failed to save signature. Please try again.",
      };
    }
    try {
      sessionStorage.setItem("SignatureBase64", signatureDataUrl);
    } catch {
      /* ignore */
    }
    return { success: true, signature: signatureDataUrl };
  } catch (error) {
    console.error("Error saving signature:", error);
    return {
      success: false,
      message: "Failed to save signature. Please try again.",
    };
  }
}
